import Grid from '@material-ui/core/Grid';
import {makeStyles} from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

interface LoadingSpinnerProps {
    title?: string;
    message?: string;
}

const useStyles = makeStyles(() => ({
    wrapper: {
        width: '100%',
        height: '100%',
        background: 'rgba(255,255,255,0.8)',
        left: 0,
        top: 0,
        position: 'fixed',
        zIndex: 199999,
        textAlign: 'center',
    },
    title: {
        fontFamily: 'FredokaRegular',
        fontWeight: 500,
        fontSize: '26px',
        lineHeight: '39px',
        color: '#3f51b5',
        marginTop: '18px',
    },
    message: {
        fontFamily: 'FredokaRegular',
        fontWeight: 400,
        fontSize: '18px',
        lineHeight: '27px',
        color: '#3f51b5',
    },
}));

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({title, message}) => {
    const classes = useStyles();
    return (
        <Grid container classes={{root: classes.wrapper}} alignContent="center" justify="center">
            <Grid item>
                <svg width="97" height="97" viewBox="0 0 97 97" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        cx="50"
                        d="M91.9183 28.3447C80.5587 4.44513 51.8601 -5.76147 27.9605 5.59819C27.4786 5.81896 27.0453 6.13331 26.6859 6.52298C26.3265 6.91265 26.0482 7.36986 25.867 7.86805C25.6859 8.36624 25.6055 8.89546 25.6307 9.42496C25.6558 9.95446 25.786 10.4737 26.0135 10.9525C26.2411 11.4312 26.5616 11.86 26.9563 12.2138C27.351 12.5677 27.8121 12.8396 28.3128 13.0137C28.8135 13.1878 29.3438 13.2606 29.8729 13.228C30.402 13.1953 30.9193 13.0579 31.3948 12.8235C51.3893 3.31999 75.1894 11.7845 84.693 31.779C94.1965 51.7734 85.732 75.5736 65.7375 85.0771C65.2556 85.2979 64.8223 85.6122 64.4629 86.0019C64.1036 86.3916 63.8252 86.8488 63.644 87.347C63.4629 87.8451 63.3825 88.3744 63.4077 88.9039C63.4328 89.4334 63.563 89.9526 63.7905 90.4314C64.0181 90.9101 64.3386 91.3389 64.7333 91.6928C65.128 92.0466 65.5891 92.3185 66.0898 92.4926C66.5905 92.6667 67.1208 92.7395 67.6499 92.7069C68.179 92.6742 68.6963 92.5368 69.1718 92.3025C93.0714 80.9428 103.278 52.2442 91.9183 28.3447ZM20.4152 16.8399L17.5866 14.6378L14.1327 15.5788L12.8186 18.9109L13.1898 20.2742L16.0184 22.4763L19.4723 21.5352L20.7864 18.2032L20.4152 16.8399ZM45.5468 90.643L42.7253 88.4375L39.2643 89.3819L37.9503 92.714L38.3214 94.0773L41.15 96.2793L44.604 95.3383L45.918 92.0063L45.5468 90.643ZM11.6897 30.1303L8.86113 27.9282L5.40721 28.8693L4.09654 32.2084L4.46436 33.5646L7.29295 35.7667L10.7469 34.8257L12.0609 31.4936L11.6897 30.1303ZM30.5331 85.4441L27.7045 83.242L24.2506 84.183L22.9366 87.5151L23.3077 88.8784L26.1363 91.0805L29.5902 90.1394L30.9009 86.8003L30.5331 85.4441ZM8.23136 45.6575L5.39941 43.4484L1.94885 44.3964L0.63482 47.7285L1.006 49.0918L3.82753 51.2972L7.28851 50.3529L8.59919 47.0138L8.23136 45.6575ZM18.2987 75.2825L15.4701 73.0804L12.0092 74.0248L10.6951 77.3568L11.0734 78.7168L13.8949 80.9222L17.3559 79.9778L18.6699 76.6458L18.2987 75.2825ZM10.5454 61.3907L7.71679 59.1886L4.25582 60.133L2.94514 63.4721L3.32002 64.825L6.14156 67.0304L9.60253 66.0861L10.9166 62.754L10.5454 61.3907Z"
                        fill="#3F51B5"
                    />
                    <animateTransform
                        attributeName="transform"
                        begin="0s"
                        dur="4s"
                        type="rotate"
                        from="0 0 0"
                        to="360 0 0"
                        repeatCount="indefinite"
                    />
                </svg>
                {title && (
                    <Typography classes={{root: classes.title}} data-testId="decisionManualUnderwriting">
                        {title}
                    </Typography>
                )}
                {message && (
                    <Typography classes={{root: classes.message}} data-testId="decisionManualUnderwriting">
                        {message}
                    </Typography>
                )}
            </Grid>
        </Grid>
    );
};

export default LoadingSpinner;
